import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
// import { pastDateWithTodayValidation } from '@validations/utils';

export const mobileNumberFormat = /(^(\+88|0088)?(01){1}[3456789]{1}(\d){8})$/;

const emptyStringToNull = (current: string, original: string) =>
  original === "" ? null : current;

export const FAMILY_INFO = FORM_FIELDS.EMPLOYEE.FAMILY_INFO;
export const PARENT = FAMILY_INFO.PARENT;
export const SPOUSE = FAMILY_INFO.SPOUSE;
export const CHILDREN = FAMILY_INFO.CHILDREN;
export const EMERGENCY_CONTACT = FAMILY_INFO.EMERGENCY_CONTACT;
export const PERMANENT_ADDRESS = FAMILY_INFO.PERMANENT_ADDRESS;
export const PRESENT_ADDRESS = FAMILY_INFO.PRESENT_ADDRESS;
export const RATION = FAMILY_INFO.RATION;

export const parentsValidation = yup.object().shape({
  [PARENT.FATHER_NAME]: yup.string().required("Name is required"),
  // .max(50, "No longer than 50 character"),
  [PARENT.MOTHER_NAME]: yup.string().required("Name is required"),
  // .max(50, "No longer than 50 character"),
});

export const spouseValidation = yup.object().shape({
  [SPOUSE.SPOUSE_NAME]: yup.string().required("Name is required"),
  // .max(50, "No longer than 50 character"),
  [SPOUSE.SPOUSE_HOME_DISTRICT]: yup
    .number()
    .typeError("Home District is required")
    .required("Home district is required"),
  [SPOUSE.SPOUSE_OCCUPATION]: yup.string().required("Occupation is required"),
  // .max(50, "No longer than 50 character"),
  [SPOUSE.SPOUSE_ORGANIZATION]: yup.string(),
  // .max(50, "No longer than 50 character"),
  [SPOUSE.SPOUSE_DESIGNATION]: yup.string(),
  [SPOUSE.SPOUSE_LOCATION]: yup.string(),
});

export const childrenValidation = yup.object().shape({
  [CHILDREN.CHILDREN_NAME]: yup.string().required("Name is required"),
  [CHILDREN.CHILDREN_GENDER]: yup.string().required("Gender is required"),
  [CHILDREN.CHILDREN_DOB]: yup
    .string()
    // .test('validator-date', pastDateWithTodayValidation)
    .required("Date of Birth is required"),
});

export const emergencyContactValidation = yup.object().shape({
  [EMERGENCY_CONTACT.NAME]: yup.string().required("Name is required"),
  [EMERGENCY_CONTACT.RELATION]: yup.string().required("Relation is required"),
  [EMERGENCY_CONTACT.CONTACT]: yup.string().required("Number is required"),
});

export const permanentAddressValidation = yup.object().shape({
  [PERMANENT_ADDRESS.VILLAGE_HOUSE_ROAD]: yup
    .string()
    .required("Village / House / Road is required"),
  // .max(50, "No longer than 50 character"),
  [PERMANENT_ADDRESS.POST_OFFICE]: yup
    .string()
    .required("Post Office is required"),
  // .max(50, "No longer than 50 character"),
  [PERMANENT_ADDRESS.POLICE_STATION]: yup
    .string()
    .required("Police Station is required"),
  // .max(50, "No longer than 50 character"),
  [PERMANENT_ADDRESS.DISTRICT]: yup
    .number()
    .typeError("District is required")
    .required("District is required"),
  [PERMANENT_ADDRESS.TELEPHONE]: yup.string().nullable(),
  [PERMANENT_ADDRESS.MOBILE]: yup
    .string()
    .transform(emptyStringToNull)
    .nullable()
    .matches(mobileNumberFormat, "Mobile Number is not valid")
    .required("Mobile Number is required"),
});

export const presentAddressValidation = yup.object().shape({
  [PRESENT_ADDRESS.VILLAGE_HOUSE_ROAD]: yup
    .string()
    .required("Village is required"),
  // .max(50, "No longer than 50 character"),
  [PRESENT_ADDRESS.POST_OFFICE]: yup
    .string()
    .required("Post Office is required"),
  // .max(50, "No longer than 50 character"),
  [PRESENT_ADDRESS.POLICE_STATION]: yup
    .string()
    .required("Police Station is required"),
  // .max(50, "No longer than 50 character"),
  [PRESENT_ADDRESS.DISTRICT]: yup
    .number()
    .typeError("District is required")
    .required("District is required"),
  [PRESENT_ADDRESS.TELEPHONE]: yup.string().nullable(),
  [PRESENT_ADDRESS.MOBILE]: yup
    .string()
    .transform(emptyStringToNull)
    .matches(mobileNumberFormat, "Mobile Number is not valid")
    .nullable()
    .required("Mobile Number is required"),
});

export const rationValidation = yup.object().shape({
  [RATION.ELIGIBLE_RATION_NUMBER]: yup
    .string()
    .required("Eligible ration number is required"),
  [RATION.RATION_CARD_NUMBER]: yup
    .string()
    .required("Ration card number is required"),
  [RATION.OFFICE_ID]: yup
    .number()
    .typeError("Office is required")
    .required("Office is required"),
  [RATION.RECEIVING_POINT]: yup
    .string()
    .required("Receiving point is required"),
  [RATION.TOTAL_ELIGIBLE_MEMBER_FOR_RATION]: yup
    .number()
    .typeError("Total eligible member must be a number"),
});

export type ParentsFormDataType = yup.InferType<typeof parentsValidation>;
export type SpouseFormDataType = yup.InferType<typeof spouseValidation>;
export type ChildrenFormDataType = yup.InferType<typeof childrenValidation>;
export type EmergencyContactFormDataType = yup.InferType<
  typeof emergencyContactValidation
>;
export type PermanentAddressFormDataType = yup.InferType<
  typeof permanentAddressValidation
>;
export type PresentAddressFormDataType = yup.InferType<
  typeof presentAddressValidation
>;
export type RationFormDataType = yup.InferType<typeof rationValidation>;
